<template>
	<!-- 物料价格管理 -->
	<div class="systemCode">
		<div class="systemCodePC pulbic_system_oparetionBlock">
			<div class="systemCodePC-side">
				<div class="systemCodePC-side-nav">
					<div class="systemCodePC-side-nav-item pulic_cursor" @click="typeClick(index)" :class="{systemCodeActive:codeIndex===index}"
					 v-for="(item,index) of typeList" :key="index">
						<i class="el-icon-paperclip"></i>
						<span class="">{{item.SETTB99CA00||''}}</span>
					</div>
				</div>
			</div>
			<div class="systemCodePC-content">
				<div class="systemCodePC-content-btn public_operatBtn" style="margin-left: 0px;">
					<el-button class="public_saleWater_xiangqing MaterialPrice-chaxun" type="primary"  v-shiroHiden="solelist" id="查看修改记录" v-if="typeList.length>0"  @click="queryClick"><i class="iconfont icon-chaxun" style="margin-right: 10px;"></i>查看修改记录</el-button>
				</div>
				<div class="systemCodePC-content-table">
					<div class="systemCodePC-content-table-li public-table-bg">
						<div class="systemCodePC-content-table-li-type">物料名称</div>
						<div class="systemCodePC-content-table-li-text">当前价格</div>
						<div class="systemCodePC-content-table-li-oper">调整后价格</div>
					</div>	
					<div v-for="(item,index) in tableData" :key="index" class="systemCodePC-content-table-li  public-table-bg"  style="padding: 5px 0;">
						<div class="systemCodePC-content-table-li-type">{{item.SETTB109CA00||''}}</div>
						<div class="systemCodePC-content-table-li-text">{{item.oldSETTB109CA01||0}}</div>
						<div class="systemCodePC-content-table-li-oper public-chech-details" style="padding: 0 0;">
							<el-input-number  v-model="item.SETTB109CA01" :precision="2"
							 :step="1" :min="0" :max="100" @change="numChange()"></el-input-number>
						</div>
					</div>
				</div>
				<div class="systemCodePC-content-error-info" v-if="tableData.length==0">暂无数据</div>
				<div class="customerManagementPC-add-customer-btn" v-if="tableData.length>0">
					<el-button type="primary" @click="materialPriceSubmit">提交</el-button>
					<el-button type="info" @click="materialPriceReset">重置</el-button>
				</div>
			</div>
			<!-- 修改记录 -->
			<div class="public-dialog">
				<el-dialog title="修改记录" :visible.sync="modificationRecordDialog" width="70%" :closeOnClickModal='false' @close="closeDetails">
					<div class="public_operatArea">
						<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive?'public_dateActive':''" @click="getNowDay">当日</span>
						<span class="public_operatArea_yesterday pulic_cursor" :class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
						<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive?'public_dateActive':''" @click="sameMonth">当月</span>
						<span class="public_operatArea_yesterday pulic_cursor" :class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
						<div class="public_operatArea_timePicker pulic_cursor">
							<el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
							 start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor">
							</el-date-picker>
						</div>
						<el-button class="public_saleWater_xiangqing MaterialPrice-chaxun" type="primary"  style="margin-left: 30px;" @click="queryRecordClick"><i class="iconfont icon-chaxun" style="margin-right: 10px;"></i>查询</el-button>
					</div>
					<el-table :border="false" :data="tableDataDetails" style="width: 100%" max-height="100%" stripe class="public_tableColumn"
					 :default-sort="{prop: 'waterNum', order: 'descending'}" :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
						<el-table-column align="center" prop='ORMTB408CA01' label="修改时间"></el-table-column>
						<el-table-column align="center" prop='SETTB99CA00' label="企业名称"></el-table-column>
						<el-table-column align="center" prop='SETTB109CA00' label="物料名称"></el-table-column>
						<el-table-column align="center" prop='ORMTB408CA04' label="修改前价格"></el-table-column>
						<el-table-column align="center" prop='ORMTB408CA05' label="调整后价格"></el-table-column>
					</el-table>
					<div class="customerManagementPC-page">
						<el-pagination size-change="handleSizeChange" @size-change="handleSizeChangeDetails" @current-change="handleCurrentChangeDetails"
						 :current-page.sync="pageDetails" :page-sizes="[10, 20, 30, 40]" layout="total, sizes,prev, pager, next"
						 :page-size="pagesizeDetails" :total="countDetails"></el-pagination>
					</div>
				</el-dialog>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				typeList: [],
				numPrice:1,
				codeIndex: 0, //类型切换
				erpinfo:'',
				tableData: [],
				inTableData:'',
				pagesize: 10, //设置每页显示条目个数为10
				page: 1,
				count: 1,
				currentPage: 1, //设置当前页默认为1,
				// 修改记录
				modificationRecordDialog: false,
				tableDataDetails: [],
				pagesizeDetails: 10, //设置每页显示条目个数为10
				pageDetails: 1,
				countDetails: 1,
				currentPageDetails: 1, //设置当前页默认为1,
				date: [], //日期
				dateNowDayActive:false,
				dateYesterdayActive:false,
				dateNowMonthActive:false,
				dateLastMonthActive:false,
				twolevelUserLogin: true,
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				solelist: [],
			}
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
		},

		mounted() {
			this.codeList();
			this.getNowDay()
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				// currentPage: this.currentPage, //当前页数
				// pageMo: this.pageMo, //页码--默认
				// limitMo: this.limitMo, //每页条数--默认
				// pageLeft: this.pageLeft, //页码--左侧列表
				limitLeft: this.limitLeft //每页条数--左侧列表
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			//初始化数据
			init() {
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.pageLeft = this.historyInfo.pageLeft
				this.limitLeft = this.historyInfo.limitLeft
				// console.log(this.codeIndex)
			},
			materialPriceSubmit(){
				var settb109s=[]
				this.tableData.forEach(item=>{
					if(item.SETTB109CA01!=item.oldSETTB109CA01){
						settb109s.push({
							SETTB109ID:item.SETTB109ID,
							SETTB109CA01:item.SETTB109CA01,
							SETTB99ID:item.SETTB99ID,
							before:item.oldSETTB109CA01,
						})
					}
					
				})
				if(settb109s.length==0) return this.$message.error('没有需要修改的物料可提交')
				let loading = this.$loading({
					lock: true,
					text: "请求中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.5)",
				});
				var postData = {
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,
					SETTB100ID:this.erpinfo.SETTB100ID,//一级企业代码
					ORMTB408CA02:this.uobj.pertb005.pertb005ca02,
					settb109s:settb109s
				}
				var url = "/set/settb109/updateSettb109s";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close();
					}, 300);
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.queryMaterialPriceList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				});
			},
			materialPriceReset(){
				this.queryMaterialPriceList()
			},
			numChange(item) {
				//计算扣减后的金额
				// if (this.upPreferentialval == "0903") {
				// 	this.resMaterList.forEach((resitem) => {
				// 		if (resitem.SETTB109ID == item) {
				// 			resitem.newsettb109CA01 = (
				// 				resitem.SETTB109CA01 - resitem.SETTB110CA00
				// 			).toFixed(2);
				// 		}
				// 	});
				// }
			},
			// 企业查询
			codeList() {
				let loading = this.$loading({
					lock: true,
					text: "请求中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.5)",
				});
				this.typeList =[]
				this.erpinfo=''
				var postData = {
					SETTB100CA02:2,
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID
				}
				var url = "/set/settb100/selectSettb100ByCa02";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close();
					}, 300);
					// console.log(res)
					if (res.data.code == 200) {
						this.typeList = res.data.data;
						this.erpinfo=this.typeList[0]
						this.queryMaterialPriceList();
					} else {
						this.typeList=[]
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				});
			},
			// 企业查询切换
			typeClick(index) {
				this.codeIndex = index;
				this.erpinfo=this.typeList[this.codeIndex]
				this.queryMaterialPriceList();
			},
			queryMaterialPriceList() {
				//页面初始化查询
				let loading = this.$loading({
					lock: true,
					text: "请求中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.5)",
				});
				this.tableData = [];
				var url = "/set/settb109/selectPageList";
				var data = {
					SETTB109CA03:'',
					SETTB109CA00:'',
					SETTB109CD01:this.erpinfo.SETTB100ID,
					SETTB99ID:this.erpinfo.SETTB99ID,
					page: 1,
					limit: 1000,
				};
				this.axios.post(url, data).then((res) => {
						// console.log(res)
						setTimeout(() => {
							loading.close();
						}, 300);
						if (res.data.code == 200) {
							this.tableData = res.data.data || [];
							this.tableData.forEach(item=>{
								item.oldSETTB109CA01=item.SETTB109CA01
							})
							// console.log(this.tableData)
							// this.inTableData=JSON.stringify(this.tableData)
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
					.catch(() => {
						loading.close();
					});
			},
			// 每页显示条数
			// handleSizeChange(val) {
			// 	this.page = 1;
			// 	this.pagesize = val;
			// 	this.queryMaterialPriceList();
			// },
			// // 点击页码
			// handleCurrentChange(val) {
			// 	//当前页
			// 	this.page = val;
			// 	this.queryMaterialPriceList();
			// },
			queryClick() {
				this.modificationRecordDialog = true
				this.MaterialPriceListDetails()
			},
			queryRecordClick(){
				this.pageDetails = 1;
				this.MaterialPriceListDetails()
			},
			MaterialPriceListDetails() {
				//页面初始化查询
				
				this.tableDataDetails = [];
				// this.countDetails=0
				var url = "/orm/ormtb408/selectPageList";
				var data = {
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,
					// SETTB100ID:this.erpinfo.SETTB100ID,
					SETTB99ID:this.erpinfo.SETTB99ID,
					startTime: this.date[0],
					endTime: this.date[1],
					page: this.pageDetails,
					limit: this.pagesizeDetails,
				};
				let loading = this.$loading({
					lock: true,
					text: "请求中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.5)",
				});
				this.axios.post(url, data).then((res) => {
						// console.log(res)
						setTimeout(() => {
							loading.close();
						}, 300);
						if (res.data.code == 200) {
							this.countDetails = res.data.count || 1;
							this.tableDataDetails = res.data.data || [];
						} else {
							this.countDetails = 0
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
					.catch(() => {
						loading.close();
					});
			},
			closeDetails(){
				this.getNowDay()
				this.tableDataDetails = [];
				this.countDetails=0
				this.pageDetails=1
				this.pagesizeDetails=10
			},
			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(date));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive=true
				this.dateYesterdayActive=false
				this.dateNowMonthActive=false
				this.dateLastMonthActive=false
			},
			datePickerChange(e) {
				this.dateNowDayActive=false
				this.dateYesterdayActive=false
				this.dateNowMonthActive=false
				this.dateLastMonthActive=false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 86400000;
				var nowDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				this.date = [nowDay, nowDay];
				this.dateNowDayActive=false
				this.dateYesterdayActive=true
				this.dateNowMonthActive=false
				this.dateLastMonthActive=false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(hms));
				var nextdate = new Date().getTime();
				var nextDay = this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(nextdate));
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive=false
				this.dateYesterdayActive=false
				this.dateNowMonthActive=true
				this.dateLastMonthActive=false
			},
			//获取上月时间
			lastMonth() {
				// var date = this.date[0].split('-');
				// if (this.monthDate[1] == date[1]) {
				// 	if(date[1]=='01'){
				// 		var dateNext = '12';
				// 		date[0]=date[0]-1
				// 	}else{
				// 		var dateNext = date[1] - 1;
				// 	}
				// 	if (dateNext < 10) {
				// 		dateNext = "0" + dateNext;
				// 	}
				// 	this.getMonthDays(date[0], dateNext);
				// } 
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month < 10) {
					month = "0" + month;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var lastDay = new Date(year, month, 0);
				let lastDayOfPreMonth = year + "-" + month + "-" + lastDay.getDate();
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive=false
				this.dateYesterdayActive=false
				this.dateNowMonthActive=false
				this.dateLastMonthActive=true
			
			},
			// 每页显示条数
			handleSizeChangeDetails(val) {
				this.pageDetails = 1;
				this.pagesizeDetails = val;
				this.MaterialPriceListDetails();
			},
			// 点击页码
			handleCurrentChangeDetails(val) {
				//当前页
				this.pageDetails = val;
				this.MaterialPriceListDetails();
			}
		}
	}
</script>

<style scoped>
	.MaterialPrice-chaxun{
		font-size: 16px;
	}
	.selectHovers {
		background-color: #F5F7FA;
	}

	.systemCode .el-select-dropdown__item.hover {
		background-color: #fff !important;
	}

	.systemCodePC {
		display: flex;
		font-size: 16px;
		color: #333;
		padding: 30px 40px 20px 20px;
	}

	.systemCodePC-side {
		flex: .4;
	}

	.systemCodePC-side-nav-item {
		height: 40px;
		line-height: 40px;
		padding-left: 20px;
	}

	.systemCodeActive {
		background-color: #1AA0FF !important;
		color: #FFF;
	}

	.systemCodePC-side-nav-item i {
		margin-right: 5px;
	}

	.systemCodePC-side-nav-item:hover {
		background-color: #ccc;
	}

	.systemCodePC-side-nav-item:focus {
		background-color: #ccc;
	}

	.systemCodePC-content {
		flex: 2;
		padding-left: 20px;
	}

	.systemCodePC-content-table {
		margin-top: 20px;
	}

	.systemCodePC-content-table-li {
		display: flex;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #CDCDCD;
	}

	.systemCodePC-content-table-li:first-child {
		font-weight: bold;
		font-size: 16px;
		height: 48px;
		line-height: 48px;
	}

	.systemCodePC-content-table-li>div {
		flex: 1;
		text-align: center;
	}
	.systemCodePC-content-error-info{
		text-align: center;
		line-height: 40px;
		font-size: 16px;
	}
	.systemCodePC-add-code {
		padding: 0 20px;
	}

	.systemCodePC-add-code-table-li {
		display: flex;
		height: 40px;
		line-height: 40px;
		text-align: center;
	}

	.systemCodePC-add-code-table-li>div {
		border: 1px solid #CDCDCD;
		border-top: none;
	}

	.systemCodePC-add-code-table-li:first-child>div {
		border-top: 1px solid #CDCDCD;
	}

	.systemCodePC-add-code-table-li>div:first-child {
		border-right: none;
	}

	.systemCodePC-add-code-table-li>div:last-child {
		border: none;
	}

	.systemCodePC-add-code-table-li-name {
		flex: 1;
		background: rgba(240, 252, 255, 1);
	}

	.systemCodePC-add-code-table-li-ipt {
		flex: 1;
	}

	.systemCodePC-add-code-table-li-ipt input {
		height: 100%;
		width: 100%;
		border: none;
		vertical-align: top;
		box-sizing: border-box;
		text-align: center;
	}

	.systemCodePC-add-code-table-li-ipt input:focus {
		outline: none;
	}

	.systemCodePC-add-code-table-li-text {
		flex: .3;
		color: #FF4D35;
	}

	.systemCodePC-add-code-btn {
		margin-top: 20px;
		text-align: center;
	}

	.customerManagementPC-page {
		margin-top: 20px;
		text-align: right;
	}
	.customerManagementPC-add-customer-btn {
		text-align: center;
		margin: 30px 0 20px 0;
	}
</style>
